<app-content-header [sort]="sort" [status]="status" baseRoute="magazines"></app-content-header>
<ng-container *ngFor="let magazine of magazines">
  <app-entry-item
    (deleteEvent)="delete($event)"
    [date]=""
    [id]="magazine.id"
    [title]="magazine.title"
    editRoute="magazines">
    <app-publish-action (publishEvent)="togglePublish($event)" [id]="magazine.id" [published]="magazine.published"></app-publish-action>


  </app-entry-item>
</ng-container>
